import React, {useState, useEffect, useRef} from 'react';
import './timer-exercise-no-duration.css';

const TimerExercise = ({handleMoveExerciseAnimation}) => {
  const [isRunning, setIsRunning] = useState(true); // Статус таймера
  const canvasRef = useRef(null); // Посилання на canvas для малювання елементів для таймеру

  // Малювання прогрес-бару на canvas
  useEffect(() => {
    if (!canvasRef.current) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let width = 160;  // Фізичний розмір канвасу на екрані
    let height = 160; // Фізичний розмір канвасу на екрані

    if (window.innerWidth > 355 && window.innerWidth < 376) {
      width = 130;
      height = 130;
    } else if (window.innerWidth <= 355) {
      width = 110;
      height = 110;
    }

    const scale = window.devicePixelRatio || 1; // Множник для масштабування

    // Встановлюємо канвас на фізичний розмір (160px) через CSS
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;

    // Встановлюємо внутрішні розміри канвасу з урахуванням devicePixelRatio
    canvas.width = width * scale;
    canvas.height = height * scale;

    // Масштабуємо контекст канвасу
    ctx.scale(scale, scale);

    const radius = width / 2;

    // Малюємо фон
    ctx.beginPath();
    ctx.arc(radius, radius, radius - 10, 0, 2 * Math.PI);
    ctx.strokeStyle = '#6F525C';
    ctx.lineWidth = 3;
    ctx.stroke();

  }, []);

  const handlePause = () => {
    if (!isRunning) return;
    handleMoveExerciseAnimation(true);
    setIsRunning(false); // Зупинити таймер
  };

  const handleResume = () => {
    if (isRunning) return;
    handleMoveExerciseAnimation(false);
    setIsRunning(true); // Продовжити таймер
  };

  return (
    <div className='timer-container'>
      <canvas className='timer-circle'
              ref={canvasRef}
      ></canvas>
      <div
        className={`pause-time ${isRunning ? 'time-visible' : ''} `}
        onClick={handlePause}>
        <img loading="lazy"
             src={require('./timer-exercise-no-duration-img/pause-img.svg').default}
             width={36}
             height={48}
             alt="image for exercise continue"/>
      </div>
      <div
        className={`resume-time ${!isRunning ? 'time-visible' : ''}`}
        onClick={handleResume}>
        <img loading="lazy"
             src={require('./timer-exercise-no-duration-img/play-img.svg').default}
             width={36}
             height={48}
             alt="image for exercise continue"/>
      </div>
    </div>
  );
};

export default TimerExercise;
